let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("P2OWY"), load("5odbj"), load("9wTW2")]).then(() => parcelRequire('dFOTO'));